export default {
  coefficient(value) {
    if (value != null) {
      // const currentBranch = branchContext.getCurrentBranch();
      const currentBranch = null;
      const groupSeparator = currentBranch?.GeneralGroupSeparator ?? ',';
      const decimalSeparator = currentBranch?.GeneralDecimalSeparator ?? '.';
      const decimalDigits = currentBranch?.CoefficientDecimalDigits ?? 0;
      return value.numberFormat(
        decimalDigits,
        decimalSeparator,
        groupSeparator
      );
    }
  },
};
